module.exports = __webpack_public_path__ + "media/images/pirkimai-496580ba.svg";